import { render, staticRenderFns } from "./Observations.vue?vue&type=template&id=7a0b8f58"
import script from "./Observations.vue?vue&type=script&lang=js"
export * from "./Observations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports